import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {RecapProfileService} from "../../../../services/archive/recap-profile.service";
import {ReportProfile} from "../../../../model/archive/report-profile";

@Component({
  selector: 'app-archive-recap-list-dialog',
  templateUrl: './recap-list-dialog.component.html',
  styleUrls: ['./recap-list-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class RecapListDialogComponent extends CcBaseComponent {

  loading: boolean = true;
  transPartKey: string = 'profile.recap.list';
  @Input()
  dialogFormVisible: boolean = false;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  selectedRecords: string[] = [];
  differential: boolean = true;


  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private recapProfileService: RecapProfileService) {
    super(cdref, messageService, translateService);
  }

  showDialog(): void {
    this.selectedRecords = [];
    this.differential = true;
  }

  closeDialog(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(this.dialogFormVisible);
    this.markForCheck();
  }

  submit(): void {
    this.loading = true;
    this.recapProfileService.executeDiffAsync(this.differential, this.selectedRecords).subscribe(result => {
      if (result.success) {
        this.closeDialog();
      } else {
        this.errorMessage(result.message);
      }
      this.loading = false;
    })
  }

  @HostListener('document:keydown.control.enter', ['$event'])
  submitShortCut(e: KeyboardEvent) {
    if (this.dialogFormVisible && !this.loading && this.selectedRecords.length > 0) {
      this.submit();
    }
  }


}

